import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface StandaloneTopBarProps {
  backTo?: string;
  backLabel?: string;
}

export function StandaloneTopBar({ backTo = "/", backLabel = "Back" }: StandaloneTopBarProps) {
  return (
    <header className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b border-border">
      <div className="container mx-auto px-4 py-2.5 flex items-center gap-5">
        <Link to="/" className="flex items-center shrink-0 transition-transform hover:-translate-y-0.5">
          <img src="/conorbit-logo-transparent.png" alt="CONORBIT" className="h-11 w-auto" />
        </Link>
        <span className="h-7 w-px bg-border shrink-0" aria-hidden />
        <Link to={backTo} className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-4 w-4" /> {backLabel}
        </Link>
      </div>
    </header>
  );
}
